/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { ColDef } from 'ag-grid-community';
import { getPrinterFinderListItemId } from '../../resources/printer-finder.model';

@Injectable()
export class PrinterFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getPrinterFinderListItemId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      { field: 'cloudPrinterName', headerName: this.translationService.get('lbl_printer_name'), width: 130 },
    ];
  }

}
